import { deleteRequest, get, patch, post } from "./api";

const fetchVendors = (params = {}, dropdown_format = false) => {
  return get("/api/v2/vendors/", params).then((response) => {
    if (dropdown_format) {
      return response.results.map((vendor) => ({
        value: vendor.id,
        label: vendor.name,
        id: vendor.id,
        name: vendor.name,
        account: vendor.account,
      }));
    }
    return response;
  });
};

const updateVendor = (id, data) => {
  return patch(`/api/v2/vendors/${id}/`, data, "multipart/form-data");
};

const createVendor = (data) => {
  data.is_active = true;
  return post("/api/v2/vendors/", data, "multipart/form-data");
};

const deleteVendor = (id) => {
  return deleteRequest(`/api/v2/vendors/${id}/`);
};

const mergeVendors = (data) => {
  return post("/api/v2/merge_vendors/", data);
};

const approveVendor = (id) => {
  return post(`/api/v2/vendors/${id}/approve/`).then(
    (response) => response.data
  );
};

const unapproveVendor = (id) => {
  return post(`/api/v2/vendors/${id}/unapprove/`).then(
    (response) => response.data
  );
};

const fetchPendingVendorApprovals = () => {
  return get("/api/v2/vendors/pending-approvals/").then((response) => response);
};

const searchVendorAccounts = ({
  vendorId,
  vendorName,
  includeNameSearch = false,
} = {}) => {
  const formData = new FormData();
  if (vendorId) {
    formData.append("vendor_id", vendorId);
  }
  if (vendorName) {
    formData.append("vendor_name", vendorName);
  }
  formData.append(
    "include_name_search",
    includeNameSearch ? "true" : "false"
  );

  return post(
    "/api/v2/vendors/search_clients/",
    formData,
    "multipart/form-data"
  ).then((response) => response.data);
};

const createVendorsExportLink = (payload) => {
  return post("/api/v2/vendors/export-link/", payload).then(
    (response) => response.data
  );
};

export {
  fetchVendors,
  updateVendor,
  createVendor,
  deleteVendor,
  createVendorsExportLink,
  mergeVendors,
  approveVendor,
  unapproveVendor,
  fetchPendingVendorApprovals,
  searchVendorAccounts,
};
